import * as React from 'react';
import constructionImg from './static/images/construction.svg';

export const PWAUnderConstruction: React.FC = () => {
    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: '#FFFFFF',
                display: 'flex',
                flexDirection: 'column',
                fontFamily: '"Noto Sans", sans-serif'
            }}
        >
            <div
                style={{
                    display: 'grid',
                    flexDirection: 'column',
                    placeItems: 'left',
                    margin: '54px 112px 54px 112px',
                }}
            >
                <div
                    style={{
                        fontWeight: '700',
                        fontSize: '32px',
                        lineHeight: '44px',
                        color: '#374151',
                        marginBottom: '12px'
                    }}
                >
                    Coming soon
                </div>
                <div
                    style={{
                        fontWeight: '400',
                        fontSize: '16px',
                        lineHeight: '22px',
                        color: '#6B7280',
                        maxWidth: '625px'
                    }}
                >
                    Thank you for using Care+. We're currently developing this experience. In the meantime, please access your functionalities through PointCare. We appreciate your patience and understanding!
                </div>
                <div style={{ flex: '1 1 auto' }}>
                    <img
                        src={constructionImg}
                        style={{
                            height: '100%',
                            width: '100%',
                            objectFit: 'contain',
                            objectPosition: 'center'
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default PWAUnderConstruction;
